<div class="feature-parent">
  <div class="features-section"*ngIf="product$ | async as product">
    <!-- <h2 class="section-title">Key Features</h2> -->
    <table class="features-table">
      <tr *ngFor="let data of product?.keyFeatures">
        <td>
          <div class="feature-title" [innerHTML]="data.name"></div>
          <div class="feature-description" [innerHTML]="data.description"></div>
        </td>
      </tr>
    </table>
  </div>
</div> 